/* src/stores/settings.js */
import { defineStore } from 'pinia'
import SettingsService from '@/services/settingsService'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: null, // Inizializza a null
    loading: false
  }),
  
  actions: {
    async fetchSettings() {
      this.loading = true
      try {
        const { data } = await SettingsService.getSettings()
        // Qui il frontend si adegua passivamente al backend
        this.settings = data 
      } catch (e) {
        console.error("Errore fetchSettings:", e)
      } finally {
        this.loading = false
      }
    }
  }
})